import {HoobiizVisibility} from '@shared/dynamo_model';

export const HoobiizVisibilityLabels: Record<HoobiizVisibility, string> = {
  [HoobiizVisibility.Public]: 'Actif',
  [HoobiizVisibility.Private]: 'Inactif',
  [HoobiizVisibility.PrivateHidden]: 'Caché',
};
